import { render, staticRenderFns } from "./StatementPrint.vue?vue&type=template&id=1b0c49fe&scoped=true&"
import script from "./StatementPrint.vue?vue&type=script&lang=js&"
export * from "./StatementPrint.vue?vue&type=script&lang=js&"
import style0 from "./StatementPrint.vue?vue&type=style&index=0&id=1b0c49fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c49fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
